var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.ZI=require("moment");module.exports=$CLJS.ZI;